<template>
    <nav class="historic__pagination">
        <ul v-for="item in this.Pages" class="pagination">
            <li v-if="item.route == null" class="page-item" >
                <a class="page-link">{{item.display}}</a>
            </li>
            <li v-else-if="paginaAtual == item.display" class="page-item pg-active">
                <a class="page-link">{{item.display}}
                    <span class="sr-only">(current)</span>
                </a>
            </li>
            <li v-else class="page-item">
                <a class="page-link" @click="navigate(item.route);">{{item.display}}</a>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    methods: {
        pagination(){
            let arrayResposta = []
            for (let i = 1; i <= this.paginasTotais; i++) {
                arrayResposta.push({display:i, route:i })
            }
            if(this.paginasTotais > 5) {
                if(this.paginaAtual <= 2){
                    arrayResposta = arrayResposta.slice(0, 4)
                    arrayResposta.push({display:"...", route:null })
                }
                else if(this.paginaAtual > this.paginasTotais - 1){
                    arrayResposta = arrayResposta.slice(this.paginaAtual-4, this.paginaAtual+1)
                    arrayResposta.unshift({display:"...", route:null })
                }
                else if(this.paginaAtual > this.paginasTotais - 2){
                    arrayResposta = arrayResposta.slice(this.paginaAtual-3, this.paginaAtual+1)
                    arrayResposta.unshift({display:"...", route:null })
                }
                else{
                    arrayResposta = arrayResposta.slice(this.paginaAtual-2, this.paginaAtual+1)
                    arrayResposta.push({display:"...", route:null })
                    arrayResposta.unshift({display:"...", route:null })
                }
            }
            if ( this.paginaAtual == 1 || this.paginasTotais <= 1){
                arrayResposta.unshift({display:"<", route:null })
                arrayResposta.unshift({display:"<<", route:null})
            }else{
                arrayResposta.unshift({display:"<", route:this.paginaAtual-1 })
                arrayResposta.unshift({display:"<<", route: 1})
            }
            if(this.paginaAtual >= this.paginasTotais){
                arrayResposta.push({display:">", route:null })
                arrayResposta.push({display:">>", route:null })
            }else{
                arrayResposta.push({display:">", route:this.paginaAtual+1 })
                arrayResposta.push({display:">>", route: this.paginasTotais})
            }
            return arrayResposta
        },
    },
    props: ['paginasTotais','paginaAtual','navigate'],
    computed: {
        Pages() {
            return this.pagination();
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "../assets/styles/iouu/variables";
    @import "../assets/styles/iouu/mixins";

    .historic {
        &__tit-page {
            margin-bottom: 30px;

            // DESKTOP
            @include ds {
                margin-bottom: 15px;
                h1 {
                    @include font-size(25px);
                }
            }
        }

        &__filter {
            .bg-filter, .bg-pag {
                border-radius: 5px;
            }

            .bg-filter {
                margin-bottom: 25px;
                padding: 25px 20px;
                background: #eee;
            }

            .bg-pag {
                padding: 20px;
                background: #f6f6f6;
            }

            // DESKTOP
            @include ds {
                @include font-size(12px);
                .bg-filter {
                    padding: 15px;
                    margin-bottom: 15px;
                }
                .bg-pag {
                    padding: 15px;
                }
            }
        }

        &__pagination {
            display: flex;
            justify-content: center;

            a {
                color: #666;
                margin-left: 2px;
                margin-right: 2px;
            }
            // .page-item{
            //     text-align: center;
            //     min-width: 45px;
            // }
            .page-item.pg-active {
                .page-link {
                    background: $c3;
                    border-color: $c3;
                    color: white;
                }
            }

            // DESKTOP
            @include ds {
                @include font-size(12px);
            }
        }
        .nav {
            li {
                position: relative;

                &:first-child {
                    border-right: 1px solid #ccc;
                }
            }
            a {
                font-weight: bold;
                color: #999999;
                @include font-size(15px);

                i {
                   background: url(/static/assets/images/icon-arrow.svg) no-repeat;
                   background-size: auto;
                   width: 13px;
                   height: 13px;
                   display: block;
                   position: relative;
                   top: 5px;
                }

                &:hover {
                    color: $c3;
                }

                &.back {
                    i {
                        margin-right: 10px;
                        float:left;
                        transform: rotate(180deg);
                    }

                    &.disabled {
                    color: #ccc;
                    i {
                        margin-right: 5px;
                        background: url(/static/assets/images/icon-arrow-back.svg) no-repeat;
                        transform: rotate(0deg);
                    }
                    }
                }

                &.next {
                    i {
                        margin-left: 10px;
                        float:right;
                    }

                    &.disabled {
                        color: #ccc;
                        i {
                            margin-right: 5px;
                            background: url(/static/assets/images/icon-arrow.svg) no-repeat;
                            transform: rotate(0deg);
                        }
                     }
                }


            }
        }

        .filter {
             color: #666;
            button {
                padding-left: 20px;
                padding-right: 20px;
            }
        }

        .filters {
            label {
                padding:0px;
                margin:0 15px 0 0;

                span {
                    width: 100%;
                }
            }

            input {
                width: 180px;
                margin: 0 10px;
            }

            // MOBILE
            @include xs {
                width: 100%;
                text-align: center;
                label {
                    @include font-size(12px);
                    margin:0 0 15px;
                    width: 100%;
                }
                input,
                textarea {
                    width: 100%;
                    @include font-size(12px);
                }
                select {
                    margin-right:0px;
                    @include font-size(12px);
                }
            }

            // DESKTOP
            @include ds {
                input,
                textarea {
                    @include font-size(11px);
                }
                select {
                    @include font-size(11px);
                }
            }
        }

        .pagination {
            color: #666;

            input {
                width: 60px;
                margin: 0 10px;
                text-align: center;
            }

            // MOBILE
            @include xs {
                .font-weight-bold {
                    margin-bottom: 10px;
                }
                span {
                    display: block;
                }
                button {
                    width: 50px;
                }
            }
        }

        form {
            input {
                color: #999;
                margin:0px;
            }
            select {
                &.score {
                    margin: 0 0 0 10px;
                }
            }
            button {
                text-transform: uppercase;
                padding-left: 15px;
                padding-right: 15px;
                font-weight: bold;
                margin: 0 10px;
            }

            // MOBILE
            @include xs {
                display: flex;
                flex-direction: row;
                @include font-size(12px);
                input {
                    @include font-size(12px);
                }
                button {
                    @include font-size(12px);
                    display: block;
                    width: 100%;
                }
            }

            // DESKTOP
            @include ds {
                button {
                    @include font-size(12px);
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue